import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment-timezone';
import { Controller, useFormContext } from 'react-hook-form';

const fieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#fff',
    borderRadius: '4px'
  }
};

const CarrierChangeDetails = ({ prefix, label }) => {
  const { control, watch } = useFormContext();
  const changeType = watch(`${prefix}ChangeType`);
  const changeTypeLabelId = `${prefix}-change-type-label`;

  return (
    <Accordion
      defaultExpanded
      disableGutters
      sx={{
        border: '1px solid #8bcdf4',
        borderRadius: '4px !important',
        boxShadow: 'none',
        overflow: 'hidden',
        '&:before': { display: 'none' }
      }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: '#005eb8' }} />}
        sx={{
          minHeight: 48,
          flexDirection: 'row-reverse',
          gap: 1.5,
          color: '#004c97',
          backgroundColor: '#e9f5fd',
          '&.Mui-expanded': { minHeight: 48 },
          '& .MuiAccordionSummary-content': { margin: '12px 0' }
        }}>
        <Typography fontWeight={700}>{label} Carrier Details</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: { xs: 2, md: 3 } }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Controller
              name={`${prefix}CarrierName`}
              control={control}
              defaultValue=""
              rules={{ required: 'Carrier Name is required' }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Carrier Name"
                  required
                  fullWidth
                  size="small"
                  sx={fieldSx}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message || ' '}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controller
              name={`${prefix}EffectiveDate`}
              control={control}
              defaultValue={null}
              rules={{ required: 'Carrier Effective Date is required' }}
              render={({ field, fieldState }) => (
                <DatePicker
                  label="Carrier Effective Date"
                  format="MM/DD/YYYY"
                  value={field.value ? moment(field.value, 'MM/DD/YYYY') : null}
                  onChange={(value) => field.onChange(value?.isValid() ? value.format('MM/DD/YYYY') : '')}
                  slotProps={{
                    textField: {
                      required: true,
                      fullWidth: true,
                      size: 'small',
                      sx: fieldSx,
                      error: !!fieldState.error,
                      helperText: fieldState.error?.message || ' '
                    }
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controller
              name={`${prefix}ChangeType`}
              control={control}
              defaultValue=""
              rules={{ required: 'Additional or Replacement of Carrier is required' }}
              render={({ field, fieldState }) => (
                <FormControl fullWidth required size="small" error={!!fieldState.error} sx={fieldSx}>
                  <InputLabel id={changeTypeLabelId}>Additional or Replacement of Carrier</InputLabel>
                  <Select {...field} labelId={changeTypeLabelId} label="Additional or Replacement of Carrier">
                    <MenuItem value="Additional">Additional</MenuItem>
                    <MenuItem value="Replacement">Replacement</MenuItem>
                  </Select>
                  <FormHelperText>{fieldState.error?.message || ' '}</FormHelperText>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controller
              name={`${prefix}ContactName`}
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField {...field} label="Contact Name(s)" fullWidth size="small" sx={fieldSx} helperText=" " />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controller
              name={`${prefix}ContactEmail`}
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Contact Email(s)"
                  fullWidth
                  size="small"
                  sx={fieldSx}
                  helperText=" "
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controller
              name={`${prefix}ContactPhone`}
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Contact Phone Number(s)"
                  fullWidth
                  size="small"
                  sx={fieldSx}
                  helperText=" "
                />
              )}
            />
          </Grid>
          {changeType === 'Replacement' && (
            <Grid item xs={12}>
              <Controller
                name={`${prefix}TerminatingCarrierName`}
                control={control}
                defaultValue=""
                shouldUnregister
                rules={{ required: 'Replacement carrier details are required' }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    label="Terminating carrier, discontinued data type, and expected runout period"
                    required
                    fullWidth
                    multiline
                    minRows={2}
                    sx={fieldSx}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message || ' '}
                  />
                )}
              />
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default CarrierChangeDetails;
